export function formatAvailableFrom(
  dateString?: string,
  locale: string = "en",
) {
  if (!dateString) return null;

  const safeDate = new Date(`${dateString}T12:00:00Z`);

  const formatter = new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  // Extract the parts, capitalize ONLY the month, and join them back together
  const parts = formatter.formatToParts(safeDate);
  const capitalizedString = parts
    .map((part) => {
      if (part.type === "month") {
        return part.value.charAt(0).toUpperCase() + part.value.slice(1);
      }
      return part.value;
    })
    .join("");

  return capitalizedString;
}
